import React from 'react';
import TimezoneSelect from "react-timezone-select";
import { customStyles } from "./Select";


const CustomTimezoneSelect = (props) => (
    <TimezoneSelect
        {...props}
        styles={customStyles(props?.onError)}
    />
)

export default CustomTimezoneSelect;